<script setup lang="ts">
import { NewLeadEndpoint, LeadSchema } from '~/helpers/leads';
import type { LeadSchemaT } from '~/helpers/leads';
import type { FormSubmitEvent } from '#ui/types'
const { gtag } = useGtag()
import Alert from '../content/Alert.vue';

const state = reactive({
	email: undefined,
	first_name: undefined,
	company_name: undefined,
	type: 'AUTOMATION',
	token: undefined
})

const loading = ref(false)
const complete = ref(false)
const error = ref(undefined)

async function onSubmit(event: FormSubmitEvent<LeadSchemaT>) {

	loading.value = true

	const response = await fetch(NewLeadEndpoint, {
		method: 'POST',
		body: JSON.stringify(event.data)
	})

	if (response.ok) {
		complete.value = true

		const data = await response.json()

		gtag('event', 'automation_lead', {
			send_to: 'AW-16674166403/2GMsCJDIjssZEIOt7o4-',
			value: 1.0,
			currency: 'USD',
			transaction_id: 'leads_'+data.id
		})
	}
	else {
		error.value = 'There was an error submitting your request. Please try again.'
	}

	loading.value = false
}

</script>

<template>
	<div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
		<div
			class="relative isolate overflow-hidden bg-gray-900 px-6 py-6 shadow-2xl sm:rounded-3xl sm:px-6 xl:py-12 border-solid border-2 border-primary">
			<h2 class="mx-auto max-w-2xl text-center text-3xl font-bold tracking-tight text-white sm:text-4xl">Free
				Workflow <br /> Automation Quote</h2>

			<UForm :schema="LeadSchema" :state="state" class="space-y-4 mt-4 px-3.5" @submit="onSubmit" v-if="!complete">

				<UFormGroup label="Your First Name" name="first_name"
					class="min-w-0 flex-auto rounded-md text-white  sm:text-md sm:leading-6">
					<UInput v-model="state.first_name" />
				</UFormGroup>

				<UFormGroup label="Your Company Name" name="company_name"
					class="min-w-0 flex-auto rounded-md text-white  sm:text-md sm:leading-6">
					<UInput v-model="state.company_name" />
				</UFormGroup>

				<UFormGroup label="Your Email" name="email"
					class="min-w-0 flex-auto rounded-md text-white  sm:text-md sm:leading-6">
					<UInput v-model="state.email" />
				</UFormGroup>

				<NuxtTurnstile v-model="state.token" :options="{
					theme: 'dark',
					appearance: 'interaction-only'
				}" />

				<UButton type="submit"
					:disabled="!state.email || !state.first_name || !state.company_name || !state.token"
					:loading="loading"
					class="min-w-0 flex-auto rounded-md py-2 text-white  sm:text-sm sm:leading-6">
					<Icon name="ph:robot-duotone" class="flex-shrink-0 h-6 w-6 align-[-5px]" />Send me a Request Form
				</UButton>

				<Alert v-if="error" type="error">{{ error }}</Alert>

				<p class="text-sm">We’ll email you a request form. Complete and return it to get your free quote. </p>


			</UForm>



			<div class="mx-auto mt-10 flex flex-col max-w-md gap-4" v-else>
				<p class="text-white text-center">Thank you for your interest in automating your workflows. Please check
					your email for details.</p>
			</div>


			<svg viewBox="0 0 1024 1024" class="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2"
				aria-hidden="true">
				<circle cx="512" cy="512" r="512" fill="url(#759c1415-0410-454c-8f7c-9a820de03641)"
					fill-opacity="0.7" />
				<defs>
					<radialGradient id="759c1415-0410-454c-8f7c-9a820de03641" cx="0" cy="0" r="1"
						gradientUnits="userSpaceOnUse" gradientTransform="translate(512 512) rotate(90) scale(512)">
						<stop stop-color="#f3cf48" />
						<stop offset="1" stop-color="#f3cf48" stop-opacity="0" />
					</radialGradient>
				</defs>
			</svg>
		</div>
	</div>
</template>
